/**
 * Created by Maria on 11/5/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('adminCycleReport', {
                parent: 'app',
                url: '/cycle/report',
                data: {
                    authorities: ['ROLE_MANAGEMENT', 'ROLE_ACCOUNTING_DEP']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminCycleReport/adminCycleReport.html',
                        controller: 'AdminCycleReportController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
